import { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import S3Uploader from 'components/admin/pages/GeneralUploader/components/FileS3Multipart';
import Button from 'components/shared/Button/Button';
import Input from 'components/shared/Input/Input';
import BaseModal from 'components/shared/Modal/Modal';

import { CHUNK_SIZE, FILE_UPLOAD_STATUS } from '../../GeneralUploader/components/lib/constants';
import useVideoFormik from '../lib/useVideoFormik';
import useVideoUploader from '../lib/useVideoUploader';

const Modal = ({ item: video, isOpen, handleClose }) => {
  const [files, setFiles] = useState([]);
  const [uploadProgressList, setUploadProgressList] = useState([]);
  const queryClient = useQueryClient();
  const { uploading, uploadFiles } = useVideoUploader();

  const formik = useVideoFormik(video, async (values, formikHelpers) => {
    await handleUpload(files, values);
    await queryClient.invalidateQueries({ queryKey: ['videos'] });
    setFiles([]);
    formikHelpers.resetForm();
    handleClose();
  });

  const handleUpload = async (files, formData = {}) => {
    const progressInit = files.map((file) => ({
      filename: file.name,
      progress: 0,
      total: Math.ceil(file.size / CHUNK_SIZE),
      size: file.size,
      status: FILE_UPLOAD_STATUS.INITIATED
    }));

    setUploadProgressList(progressInit);
    await uploadFiles(
      files,
      { filename: files[0].name, contentType: files[0].type, ...formData },
      setUploadProgressList
    );
  };

  return (
    <BaseModal
      customStyling={{ width: '700px' }}
      isOpen={isOpen}
      handleClose={handleClose}
      title="Upload video"
      slideFromRight
      footer={
        <div className="flex w-full justify-end gap-4">
          <Button
            style="outlined"
            text="Cancel"
            color="neutral"
            onClick={handleClose}
            id="closeVendorModalBtn"
          />
          <Button
            outlined
            isDisabled={files.length === 0 || uploading}
            text={video ? 'Update' : 'Upload video'}
            onClick={formik.handleSubmit}
            color="primary"
            id="createUpdateVendorModalBtn"
          />
        </div>
      }>
      <S3Uploader
        formats=".mov,.mp4"
        files={files}
        setFiles={setFiles}
        maxFiles={1}
        onUpload={handleUpload}
        uploadProgressList={uploadProgressList}
      />
      <div className="px-4">
        <Input
          label="Description"
          name="description"
          value={formik.values.description}
          onChange={formik.handleChange}
          required
          error={formik.touched.description && formik.errors.description}
        />
        <Input
          label="Thumbnail URL"
          name="thumbnail_url"
          value={formik.values.thumbnail_url}
          onChange={formik.handleChange}
          error={formik.touched.thumbnail_url && formik.errors.thumbnail_url}
        />
      </div>
    </BaseModal>
  );
};

export default Modal;
